import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateQuizRes;
export const addUpdateQuizTodo = createAsyncThunk('addUpdateQuiz', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/add_update_quiz',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "quiz_id": data.id,
                "quiz_title": data.title,
                "department_name": data.department,
                "status": data.status,
                "created_by": user_id.vemp_code,
                "new_question_ids": data.question,
                "old_question_ids": data.old_question,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateQuizRes = res.data
    } catch (error) {
        return addUpdateQuizRes = error.response.data
    }
})